import { createShell } from '../../shell/createShell';
import { route as primeFreeCancellationConfirmationRoute } from './pages/primeFreeCancellationConfirmation/primeFreeCancellationConfirmation.js';
import { route as primeFreeCancellationErrorRoute } from './pages/primeFreeCancellationError/primeFreeCancellationError.js';
import { route as primeFreeCancellationTripManagementRoute } from './pages/primeFreeCancellationTripManagement/primeFreeCancellationTripManagement.js';
import { FreeCancellationFunnel } from '.';
const routes = [primeFreeCancellationConfirmationRoute, primeFreeCancellationErrorRoute, primeFreeCancellationTripManagementRoute];
export const freeCancellationShell = createShell(FreeCancellationFunnel, {
  options: {
    routes,
    namespace: 'free_cancellation_shell'
  }
});